var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeague(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 14.5,
    className: "st0",
    width: 16.8,
    height: 3.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 14.5,
    className: "st0",
    width: 3.5,
    height: 3.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 6.7,
    className: "st0",
    width: 16.8,
    height: 3.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 6.7,
    className: "st0",
    width: 3.5,
    height: 3.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 22.3,
    className: "st0",
    width: 16.8,
    height: 3.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 22.3,
    className: "st0",
    width: 3.5,
    height: 3.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeague);
export default __webpack_public_path__ + "static/media/league.f712522f.svg";
export { ForwardRef as ReactComponent };